import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  openModal(){
    window.location.href = 'https://secure.opinionlab.com/ccc01/comment_card_d.asp?referer=https%3A%2F%2Fnextgen.cardinalhealth.com/closure&customVars=%7Bkey1%3A%20%27value1%27%2C%20key2%3A%20%27value2%27%2C%20key3%3A%20%27value3%27%7D';
  }

}
